






















import Vue from "vue";

export default Vue.extend({
  name: "ProjectsList",
  props: {
    projects: Array,
  },

  methods: {
    openURL: function(url: string) {
      window.open(url);
    },
  },
});
